import React, { useEffect, useState } from "react"
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react"

// Import Swiper styles
import "swiper/css"
import "swiper/css/free-mode"
import "swiper/css/pagination"
// import "../../.."
// // Import required modules
import { FreeMode, Pagination } from "swiper"
// import {  Pagination, FreeMode } from 'swiper/modules';

// import { getAllCourses } from "../../services/operations/courseDetailsAPI"
import Course_Card from "./Course_Card"

function Course_Slider({ Courses }) {
  
  const [slidesPerView, setSlidesPerView] = useState(3); // Default to 3 slides for large screens

  // Adjust slides per view based on window width
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        // For small screens (mobile devices)
        setSlidesPerView(1);
      } else {
        // For larger screens (tablets and desktops)
        setSlidesPerView(3);
      }
    };

    handleResize(); // Initial check on component mount

    window.addEventListener("resize", handleResize); // Listen for window resize events
    return () => window.removeEventListener("resize", handleResize); // Clean up on component unmount
  }, []);
  return (
    <>
      {Courses?.length ? (
        <Swiper
           slidesPerView={slidesPerView}
          spaceBetween={25}
           freeMode={true}
          loop={true}
          breakpoints={{
            1024: {
              slidesPerView: 3,
            },
          }}
           pagination={{
            clickable: true,
          }}
          autoplay={{
            delay: 2000,
            disableOnInteraction: false,
          }}
          className="max-h-[30rem]"
        >
          {Courses?.map((course, i) => (
            <SwiperSlide key={i}>
              <Course_Card course={course} Height={"h-[250px]"} />
            </SwiperSlide>
          ))}
        </Swiper>
      ) : (
        // <div className="spinner item-center"></div>
       <div className="grid  place-items-center">
        <div className="spinner"></div>
      </div>
      )}
    </>
  )
}

export default Course_Slider
